import LogoAnimation from './modules/animation/LogoAnimation';
import Navigation from './modules/Navigation';
import PeopleSearch from './modules/search/PeopleSearch';
import Expertise from './modules/people/Expertise';
import People from './modules/people/People';
import LikeMinds from './modules/people/LikeMinds';
import Search from './modules/search/Search';
import Modal from './modules/Modal';
import RecentEvents from './modules/private-client/RecentEvents';
import NewsletterSubscribe from './modules/private-client/NewsletterSubscribe';
import UpcomingEvents from './modules/private-client/UpcomingEvents';

window.htmx = require('htmx.org');

const navigation = new Navigation();
if(document.querySelector('.expertise__page')) {
    const exp = new Expertise();
}

if(document.querySelector('.person')) {
    const lm = new LikeMinds();
}

if(document.querySelector('.people')) {
    const people = new People();
}

if(document.querySelector('.logo-animation')) {
    const logoAnim = new LogoAnimation();
}

if(document.querySelector('.people__filter')) {
  const peopleSearch = new PeopleSearch();
}

if(document.querySelector('.modal')) {
    const modal = new Modal();
}

if(document.querySelector('.private-client')) {
    const recent = new RecentEvents();
    const subscribe = new NewsletterSubscribe();
    const upcoming = new UpcomingEvents();
}

// Search is on every page
Search()
